import { QA_PARAM } from './qa-param'

/** The backend test override from the bare `qa` URL param. Call it when a page request starts. */
export const getBackendTestOverrides = (): string | null => new URLSearchParams(window.location.search).get(QA_PARAM)
